document.querySelectorAll('.expand__button').forEach((button) => {
    button.addEventListener('click', () => {
        button.classList.toggle('open')
        button.textContent = 'Collapse Chart'

        document.querySelectorAll('.box').forEach((box) => {
            box.classList.toggle('open')
        })

        if (!button.classList.contains('open'))
            button.textContent = 'Expand Chart'
    })
})
